import { render } from "./PageFooterMain.vue?vue&type=template&id=33ac2253&scoped=true"
import script from "./PageFooterMain.vue?vue&type=script&lang=js"
export * from "./PageFooterMain.vue?vue&type=script&lang=js"

import "./PageFooterMain.vue?vue&type=style&index=0&id=33ac2253&scoped=true&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ac2253"]])

export default __exports__